import { render, staticRenderFns } from "./HomeButton.vue?vue&type=template&id=0882a520"
import script from "./HomeButton.vue?vue&type=script&lang=ts"
export * from "./HomeButton.vue?vue&type=script&lang=ts"
import style0 from "./HomeButton.vue?vue&type=style&index=0&id=0882a520&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports